import type { FC, ReactElement } from 'react';
import { Children, cloneElement, useState } from 'react';

import { MainContainer, MainRow, MainSection } from './styles';

export const ConfirmationForm: FC = ({ children }) => {
  const [isOnSubpage, setIsOnSubpage] = useState(false);

  return (
    <MainContainer isSubpage={isOnSubpage}>
      <MainRow>
        <MainSection>
          {Children.map(children as ReactElement[], (child: ReactElement) => cloneElement(child, { setIsOnSubpage }))}
        </MainSection>
      </MainRow>
    </MainContainer>
  );
};
